// project import
import dashboard from './dashboard';
import findMyHome from './findhome';
import documents from './documents';
import payments from './payments';
import schedule from './schedule';
import projectTracker from './projectTracker';
import aiAssistance from './aiasstance';
import claims from './claims';


// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [ dashboard,
    findMyHome,
    projectTracker,
    documents,
    payments,
    schedule,
    claims,
    aiAssistance
  ]
};

export default menuItems;
